<template>
    <v-container fluid>
        <h1>Debug</h1>
        <v-expansion-panels>
            <v-expansion-panel v-for="debugPanel in debugPanels" :key="debugPanel.name">
                <v-expansion-panel-header>
                    {{ debugPanel.name }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <component :is="debugPanel.component" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
import TopNavbar from "@/components/TopNavbar";
import ShowDebugVariables from "./ShowDebugVariables";
import DebugCallback from "./DebugCallback";
import DebugComponent from "./DebugComponent";
import DebugVuex from "./DebugVuex";
import DebugTypescript from "./DebugTypescript";
import DebugWizard from "./DebugWizard";
import TestConcurrency from "./TestConcurrency";

export default {
    name: "DebugPage",
    components: {
        TopNavbar,
        DebugTypescript,
        ShowDebugVariables,
        DebugCallback,
        DebugComponent,
        DebugVuex,
        DebugWizard,
        TestConcurrency,
    },
    data() {
        return {
            debugPanels: [
                {
                    name: "DebugCallback",
                    component: DebugCallback,
                },
                {
                    name: "DebugTypescript",
                    component: DebugTypescript,
                },
                {
                    name: "ShowDebugVariables",
                    component: ShowDebugVariables,
                },
                {
                    name: "DebugComponent",
                    component: DebugComponent,
                },
                {
                    name: "DebugVuex",
                    component: DebugVuex,
                },
                {
                    name: "DebugWizard",
                    component: DebugWizard,
                },
                {
                    name: "TestConcurrency",
                    component: TestConcurrency,
                },
            ],
        };
    },
};
</script>
